<template>
  <div
    v-if="applicationReady"
    class="available-forms"
  >
    <b-row>
      <b-col cols="12">
        <div class="page-header">
          <h1>
            Select a screening for {{ selectedUser.itemName }}
          </h1>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="!displayingForm">
      <b-col cols="12">
        <div class="page-header">
          <h3>
            There are no screenings available.
          </h3>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <div class="available-forms-navigation">
          <span
            v-for="(questionnaire, index) in questionnaires"
            :key="index"
          >
            <b-button
              v-if="displayForm(questionnaire)"
              :to="{
                name: questionnaire.route,
                params: {
                  questionnaireId: questionnaire.id
                }
              }"
              variant="green"
              class="btn-form"
              router-tag="button"
            >
              <span
                v-if="questionnaire.buttonIcon"
              >
                <img
                  class="form-icon"
                  :src="buttonIcon(questionnaire.buttonIcon)"
                >
              </span>
              <span v-else>
                {{ questionnaire.name }}
              </span>
            </b-button>
          </span>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col
        v-if="hasLastHealthCheckScreening"
        cols="12"
        class="text-center last-health-check"
      >
        <i>Last Health Check: {{ converFromMilitary(lastHealthCheckScreening.created_at) }}</i>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <div class="text-center">
          <b-button
            @click="goHome"
            class="btn-green"
          >
            <img
              src="../assets/home-icon.png"
            >
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* global moment */
import { mapActions, mapGetters } from 'vuex'
import { RESIDENT, VISITOR, BFM, PROVIDER, CONTACT } from '../store/modules/branch-user-types'
import { HEALTH_CHECK, MID_SHIFT, ENTRY, EXIT, EXIT_WITH_TEMP, IMMUNIZATION_TRACKING, COVID_VACCINE_TRACKING, TEST_TRACKING } from '../store/modules/screening-types'

export default {
  name: 'AvailableForms',
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      displayingForm: false
    }
  },
  mounted () {
    this.clearPageAlertInformation()
    if (this.isEmptyObject(this.selectedUser)) {
      this.$router.push({ name: 'home' })
    }
    this.setSelectedQuestionnaireId(0)
    this.setFormSubmitted(false)
    this.setFailedScreening(false)
    this.setFailureDescription('')
  },
  computed: {
    ...mapGetters([
      'applicationReady',
      'selectedUser',
      'lastScreeningForm',
      'lastHealthCheckScreening',
      'selectedUser'
    ]),
    ...mapGetters({
      questionnaires: 'forms/questionnaires'
    }),
    hasLastHealthCheckScreening () {
      return !this.isEmptyObject(this.lastHealthCheckScreening)
    }
  },
  methods: {
    ...mapActions([
      'clearPageAlertInformation'
    ]),
    ...mapActions({
      setSelectedQuestionnaireId: 'forms/setSelectedQuestionnaireId',
      setFormSubmitted: 'forms/setFormSubmitted',
      setFailedScreening: 'forms/setFailedScreening',
      setFailureDescription: 'forms/setFailureDescription'
    }),
    buttonIcon (icon) {
      var images = require.context('../assets/', false, /\.png$/)
      return images('./' + icon)
    },
    displayForm (questionnaire) {
      let display = true
      if (this.isSelfMode &&
        (questionnaire.route === MID_SHIFT ||
          questionnaire.route === HEALTH_CHECK ||
          questionnaire.route === COVID_VACCINE_TRACKING ||
          questionnaire.route === TEST_TRACKING ||
          questionnaire.route === IMMUNIZATION_TRACKING ||
          questionnaire.route === EXIT_WITH_TEMP ||
          (this.selectedUser.type !== BFM && questionnaire.route === EXIT))) {
        display = false
      }
      if (this.selectedUser.type === PROVIDER || this.selectedUser.type === CONTACT || this.selectedUser.type === VISITOR) {
        if (questionnaire.route === MID_SHIFT ||
            questionnaire.route === HEALTH_CHECK ||
            questionnaire.route === TEST_TRACKING ||
            questionnaire.route === COVID_VACCINE_TRACKING ||
            questionnaire.route === IMMUNIZATION_TRACKING) {
          display = false
        }
      }
      if (this.selectedUser.type === RESIDENT) {
        if (questionnaire.route === MID_SHIFT || questionnaire.route === EXIT_WITH_TEMP) {
          display = false
        }

        if (!this.isEmptyObject(this.lastScreeningForm)) {
          if (questionnaire.route === ENTRY && this.lastScreeningForm.route === ENTRY) {
            display = false
          }

          if (questionnaire.route === EXIT && this.lastScreeningForm.route === EXIT) {
            display = false
          }
        }
      } else {
        if (questionnaire.route === HEALTH_CHECK) {
          display = false
        }
        if (this.selectedUser.branchId === 67) {
          console.log('PENNSYLVANIA')
          if (questionnaire.route === MID_SHIFT) {
            display = false
          }

          if (!this.isEmptyObject(this.lastScreeningForm)) {
            if (questionnaire.route === ENTRY && this.lastScreeningForm.route === ENTRY) {
              display = false
            }

            if (questionnaire.route === EXIT || questionnaire.route === EXIT_WITH_TEMP) {
              if (this.lastScreeningForm.route === EXIT || this.lastScreeningForm.route === EXIT_WITH_TEMP) {
                display = false
              } else {
                // if (questionnaire.route === EXIT && this.selectedUser.type === BFM) {
                //   display = false
                //   console.log('Exit 3')
                // }

                if (questionnaire.route === EXIT_WITH_TEMP && this.selectedUser.type !== BFM) {
                  display = false
                }
              }
            }
          } else {
            if (questionnaire.route === EXIT && this.selectedUser.type === BFM) {
              display = false
            }

            if (questionnaire.route === EXIT_WITH_TEMP && this.selectedUser.type !== BFM) {
              display = false
            }
          }
        } else if (this.userState === 'OH') {
          if (questionnaire.route === MID_SHIFT) {
            display = false
          }

          if ((questionnaire.route === EXIT || questionnaire.route === EXIT_WITH_TEMP) && this.selectedUser.type === BFM) {
            display = false
          }

          if (!this.isEmptyObject(this.lastScreeningForm) && this.selectedUser.type !== BFM) {
            if (questionnaire.route === ENTRY && this.lastScreeningForm.route === ENTRY) {
              display = false
            }

            if (questionnaire.route === EXIT || questionnaire.route === EXIT_WITH_TEMP) {
              if (this.lastScreeningForm.route === EXIT || this.lastScreeningForm.route === EXIT_WITH_TEMP) {
                display = false
              } else {
                if (questionnaire.route === EXIT_WITH_TEMP) {
                  display = false
                }
              }
            }
          } else {
            if (questionnaire.route === EXIT && this.selectedUser.type === BFM) {
              display = false
            }

            if (questionnaire.route === EXIT_WITH_TEMP && this.selectedUser.type !== BFM) {
              display = false
            }
          }
        } else {
          if (questionnaire.route === MID_SHIFT && this.selectedUser.type !== BFM) {
            display = false
          }

          /**
           * Everyone but BFMs
           */
          if (questionnaire.route === EXIT) {
            display = false
          }

          // if (!this.isEmptyObject(this.lastScreeningForm) && this.selectedUser.type !== BFM) {
          //   if (questionnaire.route === ENTRY && this.lastScreeningForm.route === ENTRY) {
          //     display = false
          //   }
          //
          //   if (questionnaire.route === EXIT && this.lastScreeningForm.route === EXIT) {
          //     display = false
          //   }
          // }
        }
      }

      // if (this.isSelfMode) {
      //   const route = questionnaire.route
      //   display = false
      //   if (route === ENTRY) {
      //     display = true
      //     if (this.lastScreeningForm.route === ENTRY && this.$store.state.branch === 67) {
      //       display = false
      //     }
      //   }
      //   if (route === EXIT && this.lastScreeningForm.route !== EXIT && this.$store.state.branch === 67) {
      //     display = true
      //   }
      //   console.log(questionnaire)
      // }

      if (questionnaire.route === ENTRY || questionnaire.route === EXIT_WITH_TEMP || questionnaire.route === EXIT) {
        display = false
      }

      if (display) {
        this.displayingForm = true
      }
      return display
    },
    converFromMilitary (dateTime) {
      return moment(dateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD h:mm:ss A')
    }
  }
}
</script>

<style scoped lang="scss">
.page-header {
  margin-bottom: 2rem;
  text-align: center;
}

.available-forms-navigation {
  position: relative;
  text-align: center;
}

.btn-form {
  height: 200px;
  width: 200px;
}

.form-icon {
  height: auto;
  max-width: 164px;
  width: 100%;
}
</style>
